export { default as ProximityLogo } from './ProximityLogo/ProximityLogo.js';
export { default as Img } from './Img.js';
export { default as BgImg } from './BgImg.js';
export { default as Button } from './Button.js';
export { default as CookiesConsent } from './CookiesConsent/CookiesConsent.js';
